/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 * @param  {Function} 	func      	Function to debounce
 * @param  {Number} 	wait      	Time to wait in milliseconds
 * @param  {Boolean} 	immediate 	If true is passed, trigger the function on the leading edge, instead of the trailing.
 * @return {Function}
 */
/* eslint-disable */
export function debounce(func, wait = 50, immediate = false) {
	var timeout;
	return function () {
		var context = this, args = arguments;
		var later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

/**
 * Vanilla extend function.
 *
 * @link http://youmightnotneedjquery.com/
 *
 * @param  {Object} out
 * @return {Object}
 */
export function deepExtend(out) {
	out = out || {};

	for (var i = 1; i < arguments.length; i++) {
		const obj = arguments[i];

		if (!obj) {
			continue;
		}

		for (var key in obj) {
			if (obj.hasOwnProperty(key)) {
				if (typeof obj[key] === 'object') {
					out[key] = deepExtend(out[key], obj[key]);
				} else {
					out[key] = obj[key];
				}
			}
		}
	}

	return out;
};

/**
 * Wrap node in another node.
 * @param  {Node} el      Node to wrap.
 * @param  {Node} wrapper Wrapping node.
 */
export function wrap(el, wrapper) {
	el.parentNode.insertBefore(wrapper, el);
	wrapper.appendChild(el);
}

/**
 * Loop through an array/nodelist and call the passed callback function.
 * @param  {Array}   	array    	Array to be looped over.
 * @param  {Function} 	callback 	Callback function.
 * @param  {???}   		scope
 */
export function forEach(array, callback, scope) {
	for (var i = 0; i < array.length; i++) {
		callback.call(scope, i, array[i]);
	}
}
/* eslint-enable */
